export default {
  title: 'Liefersoft',
  form: {
    company_id: 'Company Id',
    login: 'Login',
    password: 'Password',
  },
  buttons: {
    save: 'Speichern',
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
  },
  toasts: {
    error: 'Änderungen konnten nicht gespeichert werden',
    success: 'Änderungen wurden gespeichert',
  },
  instructions: {
    title: 'Einrichtungsanleitung:',
    steps: {
      1: 'Gehen Sie zu “Einstellungen” > “Programm-Einstellungen” > “API/Schnittstellen”.',
      2: 'Plattform hinzufügen:\n• Klicken Sie auf die Schaltfläche “Plattformen”.\n• Geben Sie einen Benutzernamen ein (z. B. den Namen der Plattform).\n• Klicken Sie auf “Speichern”.',
      3: 'API-Daten kopieren:\n• Nach dem Speichern öffnet sich ein Fenster mit dem API-Plattform-Code.\n• Kopieren Sie die angezeigten Daten.',
    },
  },
  connected: {
    title: 'Liefersoft ist verbunden',
    description: 'Diese Integration ist eingerichtet.',
  },
};
